import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { filter, find, get, includes, isArray, isEmpty, map } from 'lodash';

import { parseParams, stringifyParams } from 'utils/urls';

import { ORDERING_OPTIONS, SHOW_FILTER_OPTIONS } from './constants';

export const useDefaultOrdering = (ordering, setOrdering) => {
  const history = useHistory();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (isEmpty(ordering.value)) {
      const params = parseParams(history.location.search, {
        parseNumbers: true,
        arrayFormat: 'comma'
      });
      const orderingParam = get(params, 'ordering');
      const orderingValue =
        find(ORDERING_OPTIONS, { value: orderingParam }) || ORDERING_OPTIONS[0];

      setOrdering(orderingValue);
      setInitialized(true);
    }
  }, [history, ordering, setOrdering]);

  return initialized;
};

const areFiltersEmpty = (filters) => {
  return (
    isEmpty(filters.tasks) &&
    isEmpty(filters.show.value) &&
    isEmpty(filters.students)
  );
};

export const useDefaultFilters = (
  filters,
  setFilters,
  studentsOptions,
  tasksOptions,
  loadingTasksOptions
) => {
  const history = useHistory();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (areFiltersEmpty(filters) && !loadingTasksOptions) {
      const params = parseParams(history.location.search, {
        parseNumbers: true,
        arrayFormat: 'comma'
      });

      let tasksParam = get(params, 'tasks', []);
      // Ensure tasks param value is always an array.
      tasksParam = isArray(tasksParam) ? tasksParam : [tasksParam];

      const tasks = filter(tasksOptions, (task) =>
        includes(tasksParam, task.id)
      );

      const showParam = get(params, 'show');
      const show =
        find(SHOW_FILTER_OPTIONS, { value: showParam }) ||
        SHOW_FILTER_OPTIONS[0];

      let studentsParam = get(params, 'students', []);
      // Ensure tasks param value is always an array.
      studentsParam = isArray(studentsParam) ? studentsParam : [studentsParam];

      const students = filter(studentsOptions, (student) =>
        includes(studentsParam, student.id)
      );

      setFilters({ show, tasks, students });
      setInitialized(true);
    }
  }, [
    history,
    filters,
    setFilters,
    studentsOptions,
    tasksOptions,
    loadingTasksOptions
  ]);

  return initialized;
};

export const useHistorySearch = (
  selectedSectionId,
  filters,
  filtersInitialized,
  ordering,
  orderingInitialized
) => {
  const history = useHistory();

  useEffect(() => {
    if (selectedSectionId && filtersInitialized && orderingInitialized) {
      const searchParams = parseParams(history.location.search, {
        parseNumbers: true
      });

      const params = {
        ...searchParams,
        section: selectedSectionId,
        tasks: map(filters.tasks, 'id'),
        students: map(filters.students, 'id'),
        show: filters.show.value,
        ordering: ordering.value
      };

      history.replace({
        search: stringifyParams(params, { arrayFormat: 'comma' })
      });
    }
  }, [
    history,
    filters,
    ordering,
    selectedSectionId,
    filtersInitialized,
    orderingInitialized
  ]);
};
